import packageJson from '../../package.json';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from './environment.interface';

export const environment: Environment = {
    envName: 'dev',
    version: packageJson.version,
    production: false,
    logLevel: 4,
    assetsBaseUrl: 'https://api.fitsvc.dev/',
    assetsApiVersion: '1',
    assetsApiKey: 'GymDKk1ryFGNljYr',
    localStorage: {
        isEncryptionEnabled: false,
        encryptionKey: 'czpiaJIv+t72/ihX4PIzg8nlLkCHZpfj'
    },
};

/*
 * logLevel 1 = DEBUG
 * logLevel 2 = INFO
 * logLevel 3 = WARNING
 * logLevel 4 = ERROR
 * logLevel 5 = FATAL/CRITICAL
 */
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.